import { useEffect, useState } from "react";
import "../../styles/modal.css";

export default function DocumentCreateModal({ open, onClose, onSubmit }) {
  const [form, setForm] = useState({
    name: "",
    isRequired: false,
    isMultiple: false,
  });

  useEffect(() => {
    if (open) document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = "auto");
  }, [open]);

  if (!open) return null;

  function handleChange(e) {
    setForm({ ...form, [e.target.name]: e.target.value });
  }

  function handleSubmit(e) {
    e.preventDefault();
    const payload = {
      name: form.name,
      isRequired: form.isRequired,
      isMultiple: form.isMultiple,
    };
    onSubmit(payload);
  }

  return (
    <div className="modalOverlay" onClick={onClose}>
      <div className="modalCard" onClick={(e) => e.stopPropagation()}>
        <h3>Ajouter un Document</h3>

        <form onSubmit={handleSubmit} className="modalForm">
          <div className="formGrid">
            <Input
              label="Nom du document"
              name="name"
              required
              onChange={handleChange}
            />

            <div className="formGroup checkboxGroup">
              <label className="checkbox">
                <input
                  type="checkbox"
                  name="isRequired"
                  checked={form.isRequired}
                  onChange={(e) =>
                    setForm({ ...form, isRequired: e.target.checked })
                  }
                />
                <span>Document obligatoire</span>
              </label>
            </div>

            <div className="formGroup checkboxGroup">
              <label className="checkbox">
                <input
                  type="checkbox"
                  name="isMultiple"
                  checked={form.isMultiple}
                  onChange={(e) =>
                    setForm({ ...form, isMultiple: e.target.checked })
                  }
                />
                <span>Autoriser plusieurs fichiers</span>
              </label>
            </div>
          </div>
          <div className="modalActions">
            <button type="button" className="btnGhost" onClick={onClose}>
              Annuler
            </button>
            <button className="btnPrimary">Créer</button>
          </div>
        </form>
      </div>
    </div>
  );
}

function Input({ label, ...props }) {
  return (
    <div className="formGroup">
      <label>{label}</label>
      <input {...props} />
    </div>
  );
}

function FileInput({ label, name, onChange }) {
  const [preview, setPreview] = useState(null);

  function handleFile(e) {
    const file = e.target.files[0];
    if (file) {
      setPreview(URL.createObjectURL(file));
      onChange(e);
    }
  }

  return (
    <div className="fileUpload">
      <label className="fileLabel">{label}</label>

      <label className="fileDrop">
        {preview ? (
          <img src={preview} alt="preview" className="filePreview" />
        ) : (
          <div className="filePlaceholder">
            <span className="fileIcon">📷</span>
            <span>Cliquer pour ajouter</span>
            <small>PNG, JPG</small>
          </div>
        )}

        <input
          type="file"
          name={name}
          accept="image/*"
          onChange={handleFile}
          hidden
        />
      </label>
    </div>
  );
}
